export default "__VITE_ASSET__D4P8FT7k__"